"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _colors = require("HubStyleTokens/colors");

var FeatureText = (0, _styledComponents.default)(_FormattedMessage.default).withConfig({
  displayName: "ChecklistItem__FeatureText",
  componentId: "lpncvj-0"
})(["font-size:", "px;"], function (_ref) {
  var fontSize = _ref.fontSize;
  return fontSize;
});

var ChecklistItem = function ChecklistItem(_ref2) {
  var tooltipMessage = _ref2.tooltipMessage,
      message = _ref2.message,
      className = _ref2.className,
      _ref2$iconName = _ref2.iconName,
      iconName = _ref2$iconName === void 0 ? 'success' : _ref2$iconName,
      _ref2$iconColor = _ref2.iconColor,
      iconColor = _ref2$iconColor === void 0 ? _colors.OBSIDIAN : _ref2$iconColor,
      _ref2$fontSize = _ref2.fontSize,
      fontSize = _ref2$fontSize === void 0 ? 14 : _ref2$fontSize;
  return _react.default.createElement("div", null, _react.default.createElement(_UITooltip.default, {
    placement: "top",
    title: tooltipMessage && _react.default.createElement(_FormattedMessage.default, {
      message: tooltipMessage
    })
  }, _react.default.createElement("div", {
    className: className + " display-inline-block",
    style: Object.assign({}, tooltipMessage && {
      cursor: 'help'
    })
  }, _react.default.createElement(_UIIcon.default, {
    className: "m-right-3",
    color: iconColor,
    name: iconName
  }), _react.default.createElement(FeatureText, {
    message: message,
    fontSize: fontSize
  }))));
};

ChecklistItem.propTypes = {
  tooltipMessage: _propTypes.default.string,
  message: _propTypes.default.string.isRequired,
  className: _propTypes.default.string,
  iconName: _propTypes.default.string,
  iconColor: _propTypes.default.string,
  fontSize: _propTypes.default.number
};
var _default = ChecklistItem;
exports.default = _default;
module.exports = exports.default;